import { Button, Heading, Typography } from '@altify/components';
import { View } from 'react-native';
import { useContent } from '@altify/utils';
import { content } from './ActionNotAllowedModal.content';
import appHelpers from 'utils/app-urls';
import { DialogOrBottomSheet } from 'components/DialogOrBottomSheet/DialogOrBottomSheet';
import { openZendesk } from 'utils/zendesk';

const ActionNotAllowedModal = ({
  title,
  description,
  onClose,
  isAuthenticated,
}: {
  title: string;
  description?: string;
  onClose: () => void;
  isAuthenticated: boolean;
}) => {
  const localizedContent = useContent(content);
  const cdnURL = appHelpers.getCDNUrl();
  const errorImg = `${cdnURL}assets/components/modal/exclamation.svg`;
  return (
    <DialogOrBottomSheet
      isOpen={true}
      dismissable={true}
      onClose={onClose}
      blurEnabled={true}
      isAuthenticated={isAuthenticated}
      footerContent={
        <View className="flex w-full items-center mt-6 gap-2">
          <Button
            size="large"
            onPress={onClose}
            text={localizedContent.understand}
          />
          <Button
            color="transparent"
            size="large"
            onPress={() => {
              onClose();
              openZendesk();
            }}
            text={localizedContent.contactSupport}
          />
        </View>
      }>
      <View className="w-full flex flex-col items-center px-8 py-4">
        <View className="w-full items-center justify-center">
          <View className="mb-4 mt-6 items-center">
            <img src={errorImg} alt="error-exclamation" className="mx-auto" />
            <Heading level={5} className="my-4 text-center">
              {title}
            </Heading>
            {description && (
              <Typography className="text-center" size="medium">
                {description}
              </Typography>
            )}
          </View>
        </View>
      </View>
    </DialogOrBottomSheet>
  );
};

export default ActionNotAllowedModal;
